import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  position: relative;
  input {
    border-radius: 3px;
    font-size: 13px;
    padding: 3px 5px;
    line-height: 24px;
    width: 150px;
  }
`;
